import { useAnalyticsShop as k } from "../../../api/repositories/analytics/useAnalyticsShop.js";
import { useRef as w, useEffect as l } from "react";
import { useFacebookPixel as P } from "../useFacebookPixel.js";
import { claimAnalyticsEvent as p } from "./eventGuard.js";
function b(c, a) {
  const o = P(c), r = w({ fbPixelCode: c, shop: a });
  r.current = { fbPixelCode: c, shop: a };
  const {
    isReady: i
  } = o, {
    mutateAsync: s
  } = k(), f = (e, t) => {
    !window || !window.fbq || window.fbq("track", e, t);
  }, m = () => {
    var e, t;
    return {
      shop_id: (e = r.current.shop) == null ? void 0 : e.id,
      shop_url: (t = r.current.shop) == null ? void 0 : t.url,
      data: {
        pixel_id: r.current.fbPixelCode
      }
    };
  }, y = (e) => {
    if (!r.current.fbPixelCode)
      return;
    const t = e.detail.ticket;
    if (!p(`facebook:Purchase:${t == null ? void 0 : t.id}`))
      return;
    const u = m(), h = [...e.detail.ticket.ticketItemList, ...e.detail.ticket.ticketComboList].map((n) => ({
      id: n.itemId,
      quantity: n.quantity,
      item_price: n.totalItems ? n.totalItems / n.quantity / 100 : n.total / 100
    })), d = {
      currency: t.ticketSummary.currency,
      value: t.ticketSummary.getTotal(),
      contents: h,
      content_type: "product"
    };
    f("Purchase", d), s({
      ...u,
      event_type: "Purchase",
      data: {
        ...u.data,
        content: d
      }
    });
  };
  return l(() => {
    i && p(`facebook:PageView:${c}`) && s({
      event_type: "PageView"
    });
  }, [i]), l(() => {
    const e = (t) => y(t);
    return window.addEventListener("analytics.purchase", e), () => {
      window.removeEventListener("analytics.purchase", e);
    };
  }, []), o;
}
export {
  b as useShopFBAnalytics
};
//# sourceMappingURL=useShopFBAnalytics.js.map
